export const ROUTE_PATH = '/gift-set';
